import { Grid, TextField, Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import PreLoader from '../PreLoader'
import { ViewFaculty } from '../../views/FacultyView'

type FacultyCometChatUser = {
  facultyInfo: ViewFaculty | null
}

export default function FacultyCometChatUser({ facultyInfo }: FacultyCometChatUser) {
  const [loading, setLoading] = useState(false)

  return <Grid item container spacing={1} maxWidth='sm' marginX='auto' >
    {
      loading ?
        <Grid item xs={12} height='calc(100vh - 200px)' > <PreLoader /> </Grid>
        :
        <>
        <Grid item xs={12} > <Typography variant='h6' >Comet Chat</Typography> </Grid>
        <Grid item xs={12}>
          <TextField
            id='has-comet-chat-user'
            label="Comet Chat UID"
            disabled
            value={facultyInfo?.has_comet_chat_user ? `f${facultyInfo.id}` : '-'}
          />
        </Grid>
        </>
    }
  </Grid>
}
